module.exports = __webpack_public_path__ + "static/display.275e1035.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/CrossBrowser/display.svg
// module id = 134
// module chunks = 1135276415346 35783957827783